"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const OsmosysIcon_1 = require("../art/OsmosysIcon");
const OsmosysChangeCase_1 = require("./OsmosysChangeCase");
const react_if_1 = require("react-if");
exports.OsmosysResourceBadge = ({ resource, icon, }) => {
    return (react_1.default.createElement(reactstrap_1.Badge, { color: "dark" },
        react_1.default.createElement(react_if_1.When, { condition: !!icon },
            react_1.default.createElement(OsmosysIcon_1.OsmosysIcon, { osysIcon: icon, iconStyle: "solid" }),
            ' '),
        react_1.default.createElement(OsmosysChangeCase_1.OsmosysChangeCase, null, resource)));
};
//# sourceMappingURL=OsmosysResourceBadge.js.map